import { Pipe, PipeTransform } from '@angular/core';
import { GoJsSearchNode } from './gojs-search-node.model';

@Pipe({
  name: 'gojsSearchNodeFilter',
})
export class GoJsSearchNodeFilterPipe implements PipeTransform {
  transform(nodes: GoJsSearchNode[], searchText: string): GoJsSearchNode[] {
    if (!searchText) {
      return nodes;
    }
    return nodes?.filter(
      (n) =>
        n.entityName.toLowerCase().includes(searchText.toLowerCase()) ||
        n.subEntityName.toLowerCase().includes(searchText.toLowerCase()),
    );
  }
}
